<template>
    <div class="internal-resources-root">
        <Header :label="$t('resourcesInternal.header')" overlap="small" />
        <UserNavSection />

        <MainLayout marginTop>
            <ProfileModule slot="right" />
            <FeaturedResource slot="right" />
            <VerifyModule slot="right" />

            <div slot="center">
                <SectionHeader style="position:relative">
                    <Breadcrumb :trace="breadcrumb" slot="left" />
                </SectionHeader>
                <Paper class="internal-resources-top-bar">
                    <div
                        v-if="folderInfo !== {} && folderInfo !== undefined"
                        class="internal-resources-folder-header"
                    >
                        <img
                            :src="imageUrl"
                            class="internal-resources-folder-header-image"
                        />
                        <div class="internal-resources-folder-data-wrapper">
                            <h2 class="internal-resources-folder-data-title">
                                {{ folderInfo.title }}
                            </h2>
                            <p
                                class="internal-resources-folder-data-description"
                            >
                                {{ folderInfo.desc }}
                            </p>
                        </div>
                    </div>
                    <FileListModule
                        v-if="hasItems"
                        :is-loading="files === []"
                        :files="filteredFiles"
                    />
                </Paper>
            </div>
            <NoContent
                v-if="!hasItems && !loading"
                slot="center"
                :caption="$t('resourcesInternal.resourceFolderNoContent')"
            ></NoContent>
            <div v-if="!hasItems && !loading" slot="center" class="text-center">
                <button class="btn btn-primary backbutton" @click="goBack">
                    {{ $t('general.back') }}
                </button>
            </div>
        </MainLayout>
    </div>
</template>

<script>
// Components
import Header from '~/components/layouts/Header';
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import UserNavSection from '~/shared/UserNavSection';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';
import VerifyModule from '~/components/miscellaneous/VerifyModule';
import NoContent from '~/components/miscellaneous/NoContent';
import FeaturedResource from '~/components/smart/FeaturedResource';
import Paper from '../../../components/builders/Paper';
import ResourceService from '~/services/ResourceService';
import URLS from '~/URLS';
import Breadcrumb from '~/shared/Breadcrumb';
import SectionHeader from '~/components/layouts/SectionHeader';
import FileListModule from './components/FileListModule';

// Assets
import FolderIcon from '~/assets/img/Folder-icon.png';

export default {
    name: 'ResourcesInternalFolder',
    components: {
        FileListModule,
        Breadcrumb,
        Paper,
        Header,
        UserNavSection,
        MainLayout,
        ProfileModule,
        VerifyModule,
        FeaturedResource,
        SectionHeader,
        NoContent,
    },
    data() {
        return {
            search: '',
            breadcrumb: [
                {
                    text: this.$t('resourcesInternal.header'),
                    to: URLS.internalResources,
                },
                {},
            ],
            files: [],
            folderID: this.$route.params.id,
            emptyFolderIcon: FolderIcon,
            loading: true,
        };
    },
    computed: {
        filteredFiles() {
            return this.files.filter(
                it => it.parent === this.folderID && it.public
            );
        },
        hasItems() {
            return this.filteredFiles.length > 0;
        },

        folderInfo() {
            return this.files === []
                ? {}
                : this.files
                      .filter(it => it.id === this.folderID)
                      .map(it => ({
                          image: it.thumbnail,
                          title: it.name,
                          desc: it.description,
                      }))[0];
        },
        imageUrl() {
            if (
                this.folderInfo &&
                this.folderInfo.image &&
                this.folderInfo.image !== '' &&
                this.folderInfo.image !== ' '
            ) {
                return this.folderInfo.image;
            } else {
                return this.emptyFolderIcon;
            }
        },
    },
    methods: {
        update() {
            return null;
        },
        goBack() {
            window.history.back();
        },
    },
    mounted() {
        ResourceService.getResources().then(res => {
            this.files = res;
            this.folderInfo
                ? (this.breadcrumb = [
                      {
                          text: this.$t('resourcesInternal.header'),
                          to: URLS.internalResources,
                      },
                      {
                          text: this.folderInfo.title,
                          to: URLS.internalResources
                              .concat('/')
                              .concat(this.folderID),
                      },
                  ])
                : null;
            this.loading = false;
        });
    },
};
</script>

<style scoped>
.internal-resources-folder-header {
    display: grid;
    grid-template-columns: 1fr 3fr;
    grid-gap: 40px;
}
.internal-resources-folder-header-image {
    width: 100%;
    height: 120px;
    object-fit: contain;
    padding: 10px;
}
.internal-resources-root {
    padding-bottom: 100px;
}
.internal-resources-top-bar {
    overflow: hidden;
}
.internal-resources-folder-data-wrapper {
    padding: 20px;
}
.internal-resources-folder-data-title {
    font-size: 20px;
    font-weight: bold;
}
.internal-resources-folder-data-description {
    font-size: 12px;
    margin-bottom: 0;
}

.backbutton {
    width: auto;
}
</style>
